import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ConfirmReplaceMediaModalPage } from './confirm-replace-media-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ConfirmReplaceMediaModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ConfirmReplaceMediaModalPage]
})
export class ConfirmReplaceMediaModalPageModule {}
